import React, { useState, useEffect } from "react";
import * as xlsx from "xlsx";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import supplierService from "../Services/supplierService";
import priceListService from "../Services/priceListService";
import customerService from "../Services/customerService";
import Dropdown from "../Components/Dropdown";

import { RxDownload } from "react-icons/rx";
import { GoUpload } from "react-icons/go";
import DatePicker from "../Components/DatePicker";

const ImportProducts = () => {
  const [products, setProducts] = useState([]);
  const [profit, setProfit] = useState(0);
  const [loading, setLoading] = useState(false);
  const [supplier, setSupplier] = useState("");
  const [customer, setCustomer] = useState("");
  const [vatPercentage, setVatPercentage] = useState("");
  const [reference, setReference] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [date, setDate] = useState(null);

  const navigate = useNavigate();

  const vatOptions = ["0%", "5%", "10%", "15%", "20%"].map((option) => ({
    label: option,
    value: option.replace("%", ""),
  }));

  useEffect(() => {
    const getSupplier = async () => {
      try {
        const response = await supplierService.fetchAll();
        setSuppliers(response.suppliers);
      } catch (e) {
        console.error("Failed to fetch suppliers", e);
      }
    };
    getSupplier();

    const getCustomer = async () => {
      try {
        const response = await customerService.fetchAll();
        setCustomers(response.customers);
      } catch (e) {
        console.error("Failed to fetch customers", e);
      }
    };
    getCustomer();
  }, []);

  useEffect(() => {
    setIsVisible(!!(supplier && date));
  }, [supplier, date]);

  const handleButtonClick = () => {
    document.getElementById("file-upload").click();
  };

  const handleCustomerClear = () => {
    setCustomer("");
  };

  const handleCustomerChange = (value) => {
    setProfit(0);
    setCustomer(value);
  };

  const handleFileSelect = (e) => {
    e.preventDefault();
    if (e.target.files.length > 0) {
      const reader = new FileReader();
      reader.onload = (e) => ProceedFileRead(e.target.result);
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const ProceedFileRead = (file) => {
    if (!file) {
      toast.error("Please upload a file!");
      return;
    }

    const workbook = xlsx.read(file, { type: "array" });
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const json = xlsx.utils.sheet_to_json(worksheet);

    const mappedData = json.map((item, index) => ({
      id: index + 1,
      vendor_code:
        typeof item.vendor_code === "string"
          ? item.vendor_code.replace("-", "")
          : item.vendor_code,
      brand: item.brand || "",
      title: item.title || "",
      quantity: item.quantity || 0,
      weight: item.WEIGHT || 0,
      delivery: item.delivery || 0,
      supplier_code: item.SUPPLIER_CODE || 0,
      order_price: item.supplier_price,
      price: item.sale_price
        ? item.sale_price
        : item.supplier_price + (item.supplier_price * profit) / 100,
      MIN_LOT: item.MIN_LOT || 0,
    }));

    setProducts(mappedData);
  };

  const UploadProducts = () => {
    setLoading(true);
    const data = {
      products,
      date,
      supplier,
      customer: customer || null,
      vat_percentage: vatPercentage,
      reference_no: reference,
    };

    priceListService.importProducts({ data }).then((response) => {
      setLoading(false);
      if (response.responseCode === 200) {
        toast.success("Products Imported successfully!");
        navigate("/products", { replace: true });
      }
    });
  };

  return (
    <main className="mx-10 my-2 px-80 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <h1 className="font-bold text-center text-3xl text-secondary mt-10">
        Add Price List
      </h1>
      <div className="flex flex-row justify-between items-end mb-2 mt-16">
        <p className="text-gray-500 text-sm font-medium">
          Upload the CSV file in the specified format to quickly add new
          products.
        </p>
        <button
          onClick={handleCustomerClear}
          className={`button-primary !bg-red-600 ${!customer ? "hidden" : "block"}`}
        >
          Clear Customer
        </button>
      </div>
      <hr />
      <div className="grid grid-cols-5 gap-4 mt-6">
        {/* <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="primary-input !bg-gray-50"
        /> */}
        <DatePicker value={date} onChange={(e) => setDate(e.target.value)} />
        <Dropdown
          styling="col-span-2"
          selected={supplier}
          placeholder="Select a Supplier"
          onChange={(value) => setSupplier(value)}
          options={suppliers.map((s) => ({ label: s.company, value: s.id }))}
        />
        <Dropdown
          styling="col-span-2"
          selected={customer}
          placeholder="Select a customer"
          onChange={handleCustomerChange}
          options={customers.map((c) => ({
            label: c.company_name,
            value: c.id,
          }))}
        />
      </div>
      <div className="grid grid-cols-4 gap-4 mt-4">
        <Dropdown
          selected={vatPercentage}
          placeholder="VAT%"
          options={vatOptions}
          onChange={(value) => setVatPercentage(value)}
        />
        <input
          type="text"
          value={reference}
          onChange={(e) => setReference(e.target.value)}
          placeholder="Enter Reference"
          className="primary-input"
        />
      </div>
      <div className="flex flex-row justify-center mt-10 gap-4">
        <button
          onClick={handleButtonClick}
          className={`bg-white border text-gray-700 font-medium text-sm px-6 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group ${isVisible && !loading ? "block" : "hidden"}`}
        >
          <RxDownload className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
          Import Price List
        </button>
        <div>
          {products.length > 0 && (
            <button
              onClick={UploadProducts}
              className={`bg-cyan-600 border text-white font-medium text-sm px-6 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group`}
            >
              {loading ? (
                <div className="flex flex-row items-center gap-4 justify-center">
                  <div className="w-5 h-5 rounded-full border-2 border-gray-200 border-t-cyan-600 border-l-cyan-600 animate-spin" />
                  <p>Processing</p>
                </div>
              ) : (
                <div className="flex flex-row items-center">
                  <GoUpload className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                  Upload {products.length} Products
                </div>
              )}
            </button>
          )}
        </div>
      </div>
      <input
        type="file"
        id="file-upload"
        onChange={handleFileSelect}
        style={{ display: "none" }}
      />
    </main>
  );
};

export default ImportProducts;
